"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabLink = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _lodash = require("lodash");
var _excluded = ["index", "label", "active", "isFocused", "customRef", "disabled", "onSelect", "large", "tabType", "currentTheme", "buttonProps"],
  _excluded2 = ["active"];
var _jsxFileName = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/Tab.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2b4j0nta0i() {
  var path = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/Tab.js";
  var hash = "3c7b0f28bb4e81c0c2f264e72b0e1fc3aefc80cc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/Tab.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 23,
          column: 8
        }
      },
      "2": {
        start: {
          line: 34,
          column: 40
        },
        end: {
          line: 34,
          column: 63
        }
      },
      "3": {
        start: {
          line: 52,
          column: 23
        },
        end: {
          line: 172,
          column: 1
        }
      },
      "4": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 57,
          column: 8
        }
      },
      "5": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 61,
          column: 7
        }
      },
      "6": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 17
        }
      },
      "7": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 38
        }
      },
      "8": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 72,
          column: 43
        }
      },
      "9": {
        start: {
          line: 85,
          column: 29
        },
        end: {
          line: 85,
          column: 65
        }
      },
      "10": {
        start: {
          line: 99,
          column: 28
        },
        end: {
          line: 99,
          column: 56
        }
      },
      "11": {
        start: {
          line: 103,
          column: 29
        },
        end: {
          line: 103,
          column: 79
        }
      },
      "12": {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 107,
          column: 27
        }
      },
      "13": {
        start: {
          line: 113,
          column: 29
        },
        end: {
          line: 113,
          column: 63
        }
      },
      "14": {
        start: {
          line: 115,
          column: 10
        },
        end: {
          line: 115,
          column: 91
        }
      },
      "15": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "16": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 169,
          column: 9
        }
      },
      "17": {
        start: {
          line: 174,
          column: 23
        },
        end: {
          line: 179,
          column: 1
        }
      },
      "18": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 177,
          column: 3
        }
      },
      "19": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 15
        }
      },
      "20": {
        start: {
          line: 178,
          column: 2
        },
        end: {
          line: 178,
          column: 14
        }
      },
      "21": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 18
        }
      },
      "22": {
        start: {
          line: 202,
          column: 62
        },
        end: {
          line: 202,
          column: 73
        }
      },
      "23": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 233,
          column: 6
        }
      },
      "24": {
        start: {
          line: 222,
          column: 26
        },
        end: {
          line: 222,
          column: 53
        }
      },
      "25": {
        start: {
          line: 237,
          column: 0
        },
        end: {
          line: 269,
          column: 2
        }
      },
      "26": {
        start: {
          line: 271,
          column: 0
        },
        end: {
          line: 288,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 15
          },
          end: {
            line: 20,
            column: 16
          }
        },
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 23,
            column: 8
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 34,
            column: 22
          }
        },
        loc: {
          start: {
            line: 34,
            column: 40
          },
          end: {
            line: 34,
            column: 63
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 15
          },
          end: {
            line: 54,
            column: 16
          }
        },
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 8
          }
        },
        line: 55
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 58,
            column: 14
          },
          end: {
            line: 58,
            column: 15
          }
        },
        loc: {
          start: {
            line: 58,
            column: 23
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 58
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 16
          }
        },
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 72,
            column: 43
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 85,
            column: 19
          },
          end: {
            line: 85,
            column: 20
          }
        },
        loc: {
          start: {
            line: 85,
            column: 29
          },
          end: {
            line: 85,
            column: 65
          }
        },
        line: 85
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 99,
            column: 18
          },
          end: {
            line: 99,
            column: 19
          }
        },
        loc: {
          start: {
            line: 99,
            column: 28
          },
          end: {
            line: 99,
            column: 56
          }
        },
        line: 99
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 103,
            column: 19
          },
          end: {
            line: 103,
            column: 20
          }
        },
        loc: {
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 103,
            column: 79
          }
        },
        line: 103
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 104,
            column: 28
          },
          end: {
            line: 104,
            column: 29
          }
        },
        loc: {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 107,
            column: 27
          }
        },
        line: 105
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 113,
            column: 19
          },
          end: {
            line: 113,
            column: 20
          }
        },
        loc: {
          start: {
            line: 113,
            column: 29
          },
          end: {
            line: 113,
            column: 63
          }
        },
        line: 113
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 114,
            column: 28
          },
          end: {
            line: 114,
            column: 29
          }
        },
        loc: {
          start: {
            line: 115,
            column: 10
          },
          end: {
            line: 115,
            column: 91
          }
        },
        line: 115
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 118,
            column: 9
          }
        },
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 123,
            column: 7
          }
        },
        line: 119
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        },
        loc: {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        },
        line: 165
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 174,
            column: 23
          },
          end: {
            line: 174,
            column: 24
          }
        },
        loc: {
          start: {
            line: 174,
            column: 40
          },
          end: {
            line: 179,
            column: 1
          }
        },
        line: 174
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 187,
            column: 3
          }
        },
        loc: {
          start: {
            line: 187,
            column: 11
          },
          end: {
            line: 234,
            column: 3
          }
        },
        line: 187
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 222,
            column: 21
          },
          end: {
            line: 222,
            column: 22
          }
        },
        loc: {
          start: {
            line: 222,
            column: 26
          },
          end: {
            line: 222,
            column: 53
          }
        },
        line: 222
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 280,
            column: 12
          },
          end: {
            line: 280,
            column: 13
          }
        },
        loc: {
          start: {
            line: 280,
            column: 18
          },
          end: {
            line: 280,
            column: 20
          }
        },
        line: 280
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 40
          },
          end: {
            line: 34,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 51
          },
          end: {
            line: 34,
            column: 57
          }
        }, {
          start: {
            line: 34,
            column: 60
          },
          end: {
            line: 34,
            column: 63
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 54,
            column: 26
          },
          end: {
            line: 54,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 54,
            column: 36
          },
          end: {
            line: 54,
            column: 42
          }
        }],
        line: 54
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 59
      },
      "3": {
        loc: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 31
          },
          end: {
            line: 62,
            column: 32
          }
        }, {
          start: {
            line: 62,
            column: 35
          },
          end: {
            line: 62,
            column: 37
          }
        }],
        line: 62
      },
      "4": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 72,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 12
          },
          end: {
            line: 71,
            column: 73
          }
        }, {
          start: {
            line: 72,
            column: 12
          },
          end: {
            line: 72,
            column: 43
          }
        }],
        line: 70
      },
      "5": {
        loc: {
          start: {
            line: 71,
            column: 12
          },
          end: {
            line: 71,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 13
          },
          end: {
            line: 71,
            column: 28
          }
        }, {
          start: {
            line: 71,
            column: 32
          },
          end: {
            line: 71,
            column: 59
          }
        }, {
          start: {
            line: 71,
            column: 64
          },
          end: {
            line: 71,
            column: 73
          }
        }],
        line: 71
      },
      "6": {
        loc: {
          start: {
            line: 72,
            column: 12
          },
          end: {
            line: 72,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 12
          },
          end: {
            line: 72,
            column: 29
          }
        }, {
          start: {
            line: 72,
            column: 33
          },
          end: {
            line: 72,
            column: 43
          }
        }],
        line: 72
      },
      "7": {
        loc: {
          start: {
            line: 85,
            column: 29
          },
          end: {
            line: 85,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 43
          },
          end: {
            line: 85,
            column: 53
          }
        }, {
          start: {
            line: 85,
            column: 56
          },
          end: {
            line: 85,
            column: 65
          }
        }],
        line: 85
      },
      "8": {
        loc: {
          start: {
            line: 99,
            column: 28
          },
          end: {
            line: 99,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 99,
            column: 43
          },
          end: {
            line: 99,
            column: 48
          }
        }, {
          start: {
            line: 99,
            column: 51
          },
          end: {
            line: 99,
            column: 56
          }
        }],
        line: 99
      },
      "9": {
        loc: {
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 103,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 103,
            column: 74
          },
          end: {
            line: 103,
            column: 75
          }
        }, {
          start: {
            line: 103,
            column: 78
          },
          end: {
            line: 103,
            column: 79
          }
        }],
        line: 103
      },
      "10": {
        loc: {
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 103,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 103,
            column: 41
          }
        }, {
          start: {
            line: 103,
            column: 45
          },
          end: {
            line: 103,
            column: 71
          }
        }],
        line: 103
      },
      "11": {
        loc: {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 107,
            column: 27
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 14
          },
          end: {
            line: 106,
            column: 75
          }
        }, {
          start: {
            line: 107,
            column: 14
          },
          end: {
            line: 107,
            column: 27
          }
        }],
        line: 105
      },
      "12": {
        loc: {
          start: {
            line: 106,
            column: 14
          },
          end: {
            line: 106,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 15
          },
          end: {
            line: 106,
            column: 30
          }
        }, {
          start: {
            line: 106,
            column: 34
          },
          end: {
            line: 106,
            column: 61
          }
        }, {
          start: {
            line: 106,
            column: 66
          },
          end: {
            line: 106,
            column: 75
          }
        }],
        line: 106
      },
      "13": {
        loc: {
          start: {
            line: 113,
            column: 29
          },
          end: {
            line: 113,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 58
          },
          end: {
            line: 113,
            column: 59
          }
        }, {
          start: {
            line: 113,
            column: 62
          },
          end: {
            line: 113,
            column: 63
          }
        }],
        line: 113
      },
      "14": {
        loc: {
          start: {
            line: 115,
            column: 10
          },
          end: {
            line: 115,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 25
          },
          end: {
            line: 115,
            column: 71
          }
        }, {
          start: {
            line: 115,
            column: 74
          },
          end: {
            line: 115,
            column: 91
          }
        }],
        line: 115
      },
      "15": {
        loc: {
          start: {
            line: 115,
            column: 25
          },
          end: {
            line: 115,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 25
          },
          end: {
            line: 115,
            column: 40
          }
        }, {
          start: {
            line: 115,
            column: 44
          },
          end: {
            line: 115,
            column: 71
          }
        }],
        line: 115
      },
      "16": {
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 123,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 22
          }
        }, {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 123,
            column: 7
          }
        }],
        line: 119
      },
      "17": {
        loc: {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 165,
            column: 22
          }
        }, {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        }],
        line: 165
      },
      "18": {
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 177,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 177,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 175
      },
      "19": {
        loc: {
          start: {
            line: 175,
            column: 6
          },
          end: {
            line: 175,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 6
          },
          end: {
            line: 175,
            column: 23
          }
        }, {
          start: {
            line: 175,
            column: 27
          },
          end: {
            line: 175,
            column: 57
          }
        }],
        line: 175
      },
      "20": {
        loc: {
          start: {
            line: 220,
            column: 19
          },
          end: {
            line: 220,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 220,
            column: 19
          },
          end: {
            line: 220,
            column: 28
          }
        }, {
          start: {
            line: 220,
            column: 32
          },
          end: {
            line: 220,
            column: 40
          }
        }],
        line: 220
      },
      "21": {
        loc: {
          start: {
            line: 225,
            column: 11
          },
          end: {
            line: 225,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 11
          },
          end: {
            line: 225,
            column: 29
          }
        }, {
          start: {
            line: 225,
            column: 33
          },
          end: {
            line: 225,
            column: 38
          }
        }],
        line: 225
      },
      "22": {
        loc: {
          start: {
            line: 226,
            column: 11
          },
          end: {
            line: 230,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 11
          },
          end: {
            line: 226,
            column: 31
          }
        }, {
          start: {
            line: 227,
            column: 12
          },
          end: {
            line: 229,
            column: 21
          }
        }],
        line: 226
      },
      "23": {
        loc: {
          start: {
            line: 227,
            column: 64
          },
          end: {
            line: 227,
            column: 95
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 227,
            column: 73
          },
          end: {
            line: 227,
            column: 90
          }
        }, {
          start: {
            line: 227,
            column: 93
          },
          end: {
            line: 227,
            column: 95
          }
        }],
        line: 227
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3c7b0f28bb4e81c0c2f264e72b0e1fc3aefc80cc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2b4j0nta0i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2b4j0nta0i();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_2b4j0nta0i().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.li.attrs({
  className: function className(_ref) {
    var tabType = _ref.tabType,
      active = _ref.active;
    cov_2b4j0nta0i().f[0]++;
    cov_2b4j0nta0i().s[1]++;
    return (0, _utils.classNames)("g-Tabs-item g-Tabs-item-".concat(tabType), {
      'g-Tabs-item-active': active
    });
  },
  role: 'presentation'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      display: inline-block;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      vertical-align: top;\n      margin-left: ", ";\n      margin-right: 1rem;\n\n      @media (max-width: 30em) {\n        margin: 0.5rem;\n      }\n    "])), function (_ref2) {
  var centered = _ref2.centered;
  cov_2b4j0nta0i().f[1]++;
  cov_2b4j0nta0i().s[2]++;
  return centered ? (cov_2b4j0nta0i().b[0][0]++, '1rem') : (cov_2b4j0nta0i().b[0][1]++, '0');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      display: inline-block;\n      list-style: none;\n      margin: 0;\n      vertical-align: top;\n      padding: ", ";\n    "])), _themeMapper.evolutionTheme.tabs.items.padding))));
var TabLink = exports.TabLink = (cov_2b4j0nta0i().s[3]++, (0, _utils.withThemedStyles)(_styledComponents.default.a.attrs({
  className: function className(_ref3) {
    var active = _ref3.active,
      _ref3$tabType = _ref3.tabType,
      tabType = _ref3$tabType === void 0 ? (cov_2b4j0nta0i().b[1][0]++, 'text') : _ref3$tabType;
    cov_2b4j0nta0i().f[2]++;
    cov_2b4j0nta0i().s[4]++;
    return (0, _utils.classNames)("g-Tabs-link g-Tabs-link-".concat(tabType), {
      'is-active': active
    });
  },
  tabIndex: function tabIndex(props) {
    var _props$themeContext;
    cov_2b4j0nta0i().f[3]++;
    cov_2b4j0nta0i().s[5]++;
    if (((_props$themeContext = props.themeContext) === null || _props$themeContext === void 0 ? void 0 : _props$themeContext.theme) === _themeProvider.TicketShopTheme.EVOLUTION) {
      cov_2b4j0nta0i().b[2][0]++;
      cov_2b4j0nta0i().s[6]++;
      return 0;
    } else {
      cov_2b4j0nta0i().b[2][1]++;
    }
    cov_2b4j0nta0i().s[7]++;
    return props.isFocused ? (cov_2b4j0nta0i().b[3][0]++, 0) : (cov_2b4j0nta0i().b[3][1]++, -1);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      box-sizing: border-box;\n      color: ", ";\n      cursor: pointer;\n      overflow: hidden;\n      user-select: none;\n      touch-action: manipulation;\n      transition: color 0.125s;\n      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n      -webkit-tap-highlight-color: transparent;\n      transition: color linear 0.125s;\n      text-align: center;\n      text-decoration: none;\n      height: calc(2.5rem + 2px);\n      line-height: calc(2.5rem - 2px);\n      font-size: ", ";\n      font-weight: 500;\n      padding: 0;\n      text-transform: uppercase;\n\n      button {\n        @media (max-width: 30em) {\n          display: block;\n          width: 100%;\n        }\n      }\n      &:after {\n        content: '';\n        position: absolute;\n        height: ", ";\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        opacity: ", ";\n        background-color: ", ";\n        will-change: opacity;\n        transition: opacity linear 0.125s;\n      }\n\n      &:hover:after {\n        opacity: ", ";\n        background-color: ", ";\n      }\n\n      ", ";\n    "])), function (props) {
  cov_2b4j0nta0i().f[4]++;
  cov_2b4j0nta0i().s[8]++;
  return props.active ? (cov_2b4j0nta0i().b[4][0]++, (cov_2b4j0nta0i().b[5][0]++, props.theme.tab) && (cov_2b4j0nta0i().b[5][1]++, props.theme.tab.activeColor) || (cov_2b4j0nta0i().b[5][2]++, '#00a6dc')) : (cov_2b4j0nta0i().b[4][1]++, (cov_2b4j0nta0i().b[6][0]++, props.theme.color) || (cov_2b4j0nta0i().b[6][1]++, '#676f7e;'));
}, function (props) {
  cov_2b4j0nta0i().f[5]++;
  cov_2b4j0nta0i().s[9]++;
  return props.large ? (cov_2b4j0nta0i().b[7][0]++, '0.875rem') : (cov_2b4j0nta0i().b[7][1]++, '0.75rem');
}, function (props) {
  cov_2b4j0nta0i().f[6]++;
  cov_2b4j0nta0i().s[10]++;
  return props.active ? (cov_2b4j0nta0i().b[8][0]++, '2px') : (cov_2b4j0nta0i().b[8][1]++, '1px');
}, function (props) {
  cov_2b4j0nta0i().f[7]++;
  cov_2b4j0nta0i().s[11]++;
  return (cov_2b4j0nta0i().b[10][0]++, props.active) && (cov_2b4j0nta0i().b[10][1]++, props.tabType !== 'button') ? (cov_2b4j0nta0i().b[9][0]++, 1) : (cov_2b4j0nta0i().b[9][1]++, 0);
}, function (props) {
  cov_2b4j0nta0i().f[8]++;
  cov_2b4j0nta0i().s[12]++;
  return props.active ? (cov_2b4j0nta0i().b[11][0]++, (cov_2b4j0nta0i().b[12][0]++, props.theme.tab) && (cov_2b4j0nta0i().b[12][1]++, props.theme.tab.activeColor) || (cov_2b4j0nta0i().b[12][2]++, '#00a6dc')) : (cov_2b4j0nta0i().b[11][1]++, 'transparent');
}, function (props) {
  cov_2b4j0nta0i().f[9]++;
  cov_2b4j0nta0i().s[13]++;
  return props.tabType !== 'button' ? (cov_2b4j0nta0i().b[13][0]++, 1) : (cov_2b4j0nta0i().b[13][1]++, 0);
}, function (props) {
  cov_2b4j0nta0i().f[10]++;
  cov_2b4j0nta0i().s[14]++;
  return props.active ? (cov_2b4j0nta0i().b[14][0]++, (cov_2b4j0nta0i().b[15][0]++, props.theme.tab) && (cov_2b4j0nta0i().b[15][1]++, props.theme.tab.activeColor)) : (cov_2b4j0nta0i().b[14][1]++, props.theme.color);
}, function (props) {
  cov_2b4j0nta0i().f[11]++;
  cov_2b4j0nta0i().s[15]++;
  return (cov_2b4j0nta0i().b[16][0]++, props.disabled) && (cov_2b4j0nta0i().b[16][1]++, "\n        opacity: 0.5;\n        pointer-events: none;\n      ");
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      box-sizing: border-box;\n      color: var(--tabTextColor, #bcc3cd);\n      cursor: pointer;\n      overflow: hidden;\n      user-select: none;\n      touch-action: manipulation;\n      transition: color 0.125s;\n      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n      -webkit-tap-highlight-color: transparent;\n      transition: color linear 0.125s;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      padding: ", ";\n\n      &.g-Tabs-link.g-Tabs-link-text {\n        &.is-active {\n          color: var(--selectedTabTextColor, var(--primaryColor));\n        }\n      }\n\n      &.g-Tabs-link-button {\n        padding: 0;\n\n        > .g-Button {\n          padding: ", ";\n        }\n      }\n\n      ", ";\n\n      ", ";\n    "])), (0, _lodash.get)(_themeMapper.evolutionTheme, 'tabs.items.fontSize', '16px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'tabs.items.lineHeight', '24px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'tabs.items.fontWeight', 500), (0, _lodash.get)(_themeMapper.evolutionTheme, 'tabs.items.padding', '12px 24px'), _themeMapper.evolutionTheme.tabs.items.button.padding, _utils.gDesktopFirstMediaQueries.sm(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n        button {\n          width: 100%;\n        }\n      "]))), function (props) {
  cov_2b4j0nta0i().f[12]++;
  cov_2b4j0nta0i().s[16]++;
  return (cov_2b4j0nta0i().b[17][0]++, props.disabled) && (cov_2b4j0nta0i().b[17][1]++, "\n          opacity: 0.5;\n          pointer-events: none;\n        ");
}))));
cov_2b4j0nta0i().s[17]++;
var handleKeyPress = function handleKeyPress(e, onSelect) {
  cov_2b4j0nta0i().f[13]++;
  cov_2b4j0nta0i().s[18]++;
  if ((cov_2b4j0nta0i().b[19][0]++, e.key === 'Enter') && (cov_2b4j0nta0i().b[19][1]++, typeof onSelect === 'function')) {
    cov_2b4j0nta0i().b[18][0]++;
    cov_2b4j0nta0i().s[19]++;
    onSelect();
  } else {
    cov_2b4j0nta0i().b[18][1]++;
  }
  cov_2b4j0nta0i().s[20]++;
  return null;
};
/**
 * Contains the link and data that should be rendered in the tabs object. This component is responsible of displaying the link to a tab
 * We use class component to make parent ref works.
 */

// eslint-disable-next-line react/prefer-stateless-function
var Tab = /*#__PURE__*/function (_React$Component) {
  function Tab() {
    (0, _classCallCheck2.default)(this, Tab);
    return _callSuper(this, Tab, arguments);
  }
  (0, _inherits2.default)(Tab, _React$Component);
  return (0, _createClass2.default)(Tab, [{
    key: "render",
    value: function render() {
      cov_2b4j0nta0i().f[14]++;
      var _ref4 = (cov_2b4j0nta0i().s[21]++, this.props),
        index = _ref4.index,
        label = _ref4.label,
        active = _ref4.active,
        isFocused = _ref4.isFocused,
        customRef = _ref4.customRef,
        disabled = _ref4.disabled,
        onSelect = _ref4.onSelect,
        large = _ref4.large,
        tabType = _ref4.tabType,
        currentTheme = _ref4.currentTheme,
        buttonProps = _ref4.buttonProps,
        rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
      var _ref5 = (cov_2b4j0nta0i().s[22]++, buttonProps),
        activeButtonProps = _ref5.active,
        restButtonProps = (0, _objectWithoutProperties2.default)(_ref5, _excluded2);
      cov_2b4j0nta0i().s[23]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
        tabType: tabType,
        currentTheme: currentTheme,
        role: "tab",
        id: "g-Tabs-link-".concat(index),
        active: active,
        "aria-selected": active,
        "aria-disabled": disabled,
        "aria-controls": "g-Tabs-panel-".concat(index)
      }, rest, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 7
        }
      }), /*#__PURE__*/_react.default.createElement(TabLink, {
        currentTheme: currentTheme,
        large: large,
        index: index,
        active: active,
        disabled: disabled,
        onClick: (cov_2b4j0nta0i().b[20][0]++, !disabled) && (cov_2b4j0nta0i().b[20][1]++, onSelect),
        tabType: tabType,
        onKeyDown: function onKeyDown(e) {
          cov_2b4j0nta0i().f[15]++;
          cov_2b4j0nta0i().s[24]++;
          return handleKeyPress(e, onSelect);
        },
        isFocused: isFocused,
        innerRef: customRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 214,
          columnNumber: 9
        }
      }, (cov_2b4j0nta0i().b[21][0]++, tabType === 'text') && (cov_2b4j0nta0i().b[21][1]++, label), (cov_2b4j0nta0i().b[22][0]++, tabType === 'button') && (cov_2b4j0nta0i().b[22][1]++, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
        outline: !active
      }, restButtonProps, active ? (cov_2b4j0nta0i().b[23][0]++, activeButtonProps) : (cov_2b4j0nta0i().b[23][1]++, {}), {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 227,
          columnNumber: 13
        }
      }), label))));
    }
  }]);
}((_react.default.Component));
cov_2b4j0nta0i().s[25]++;
Tab.propTypes = {
  /** Obviously the place in the list of the current tab */
  index: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** The name to display in the tab list */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /** If the tab is active, a specific style is applied */
  active: _propTypes.default.bool,
  /** If it is clickable or not */
  disabled: _propTypes.default.bool,
  /** style variant */
  large: _propTypes.default.bool,
  /** The function that may be pass on click */
  onSelect: _propTypes.default.func,
  /** indicate if the tabs will be centered */
  centered: _propTypes.default.bool,
  /** indicate type of button */
  tabType: _propTypes.default.oneOf(['button', 'text']),
  /** Indicating that tab being focused */
  isFocused: _propTypes.default.bool,
  /** Indicating that tab being focused */
  customRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(_react.default.Component)
  })]),
  /** */
  buttonProps: _propTypes.default.shape({
    variant: _button.ButtonVariantType,
    active: _propTypes.default.shape({})
  }),
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_2b4j0nta0i().s[26]++;
Tab.defaultProps = {
  index: 0,
  active: false,
  disabled: false,
  large: false,
  centered: false,
  tabType: 'text',
  isFocused: false,
  customRef: null,
  onSelect: function onSelect() {
    cov_2b4j0nta0i().f[16]++;
  },
  buttonProps: {
    variant: _button.ButtonVariant.primary,
    active: {}
  },
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(Tab));